/**
 * @file Renders the tab bar used inside a drawer.
 */
import { Tabs, theme } from "antd";
import type { TabsProps } from "antd";

type Props = {
  items: TabsProps["items"];
};

/**
 * Renders a small tab bar styled to bleed to the drawer's edges.
 */
const DrawerTabs = ({ items }: Props): JSX.Element => {
  const { token: { colorBgContainer } } = theme.useToken();

  const tabBarStyle = {
    marginLeft: -24,
    paddingLeft: 24,
    marginRight: -24,
    paddingRight: 24,
    backgroundColor: colorBgContainer,
  };

  return (
    <Tabs
      size="small"
      items={items}
      tabBarStyle={tabBarStyle}
    />
  );
};

export default DrawerTabs;
